import { Lightning } from '@lightningjs/sdk';
import { templates } from './slideShow.constants';
import {
  IMPRESSION_TRACK_SIGNAL,
  IMPRESSION_UNTRACK_SIGNAL,
  PORTION_REQUESTED_SIGNAL,
  SELECTED_SIGNAL,
} from '../../../signals';
import { padding } from './slideShow.style';

/**
 * SlideShow block template is currently used only for rendering of the Hero content templates.
 * It contains only minimal required code for passthrough the block data
 */
export default class SlideShow extends Lightning.Component {
  static getOffsetsByBlockData() {
    return padding;
  }

  _init() {
    this._contentPadding = 0;
  }

  get data() {
    return this._data;
  }

  set data(value) {
    this._data = value;
    const { itemSize, itemType } = this._data;

    const [currentView] = this.children;
    if (currentView) {
      currentView.data = value;

      return;
    }

    this.patch({
      ...itemSize,
      children: [
        {
          ...itemSize,
          type: itemType,
          focusMode: this._focusMode,
          data: value,
          passSignals: {
            [SELECTED_SIGNAL]: true,
            [PORTION_REQUESTED_SIGNAL]: true,
            [IMPRESSION_TRACK_SIGNAL]: true,
            [IMPRESSION_UNTRACK_SIGNAL]: true,
          },
        },
      ],
    });
  }

  get contentPadding() {
    return this._contentPadding;
  }

  set contentPadding(value) {
    this._contentPadding = Number.isFinite(value) ? value : 0;
    if (this.children[0]) {
      this.children[0].contentPadding = this._contentPadding;
    }
  }

  get focusMode() {
    if (!this.children[0]) {
      return null;
    }

    return this.children[0].focusMode;
  }

  set focusMode(value) {
    if (value !== this._focusMode) {
      if (this.children[0]) {
        this.children[0].focusMode = value;
      }
      this._focusMode = value;
    }
  }

  get focusedIndex() {
    if (!this.children[0]) {
      return 0;
    }

    return this.children[0].focusedIndex;
  }

  set focusedIndex(value) {
    if (this.children[0]) {
      this.children[0].focusedIndex = value;
    }
  }

  _getFocused() {
    return this.children[0];
  }
}

SlideShow.Templates = { ...templates };
